export enum StockMoveQueryParameters {
  SelectSearch = "select_search",
  VariantSku = "variant_sku",
  OpenSelect = "open_select",
}
